// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconCancelCircle.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconCancelCircle = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 18 16" fill="currentColor" { ...props }>
    <path d="M8.82428 16C13.4503 16 17.2004 12.4183 17.2004 8C17.2004 3.58172 13.4503 0 8.82428 0C4.19825 0 0.44812 3.58172 0.44812 8C0.44812 12.4183 4.19825 16 8.82428 16ZM6.00126 4.00006L8.82422 6.6963L11.6473 4L13.0124 5.3037L10.1892 8L13.0124 10.6963L11.6473 11.9999L8.82434 9.3037L6.00126 12L4.6362 10.6964L7.4594 8L4.6362 5.3037L6.00126 4.00006Z" />
  </BaseIcon>
);

export default IconCancelCircle;
